import React from 'react';
import styled from 'styled-components';
import { theme } from '../theme';
import Typography from './Typography';
import PropTypes from 'prop-types';

const Tag = ({
  children,
  $variant = 'default',
  $textTransform = 'uppercase',
  $letterSpacing = '1.2px',
  $textStyle = 'overline-semibold',
  $borderRadius = '16px'
}) => {
  return (
    <TagContainer $variant={$variant} $borderRadius={$borderRadius}>
      <Typography
        $variant={$textStyle}
        color={variantStyles[$variant].color}
        $textTransform={$textTransform}
        $letterSpacing={$letterSpacing}
      >
        {children}
      </Typography>
    </TagContainer>
  );
};

// Validación de props (opcional pero recomendado)
Tag.propTypes = {
  children: PropTypes.node.isRequired,
  $variant: PropTypes.oneOf([
    'brand',
    'brandSubtle',
    'transparent',
    'success',
    'warning',
    'info',
    'danger',
    'dangerDark',
    'dangerLight',
    'outline',
    'inverse',
    'subtle',
    'default',
    'blur',
    'lime',
    'attending',
    'confirmationPending',
    'rejected',
  ]),
  $textTransform: PropTypes.oneOf(['none', 'uppercase', 'lowercase', 'capitalize']),
  $letterSpacing: PropTypes.string,
  $borderRadius: PropTypes.string,
};

export default Tag;

const variantStyles = {
  brand: {
    border: 'transparent',
    background: theme.fill.brandMain,
    color: theme.colors.inverseMain,
  },
  brandSubtle: {
    border: 'transparent',
    background: theme.fill.brandAlphaMain16,
    color: theme.colors.brandMain,
  },
  transparent: {
    border: theme.border.defaultWeak,
    background: 'transparent',
    color: theme.colors.defaultStrong,
  },
  success: {
    border: 'transparent',
    background: theme.fill.successAlphaMain16,
    color: theme.colors.successMain,
  },
  warning: {
    border: 'transparent',
    background: theme.fill.warningAlphaMain16,
    color: theme.colors.warningMain,
  },
  info: {
    border: 'transparent',
    background: theme.palette.internationalOrange[100],
    color: theme.palette.internationalOrange[400],
  },
  infoDark: {
    border: 'transparent',
    background: theme.palette.internationalOrange[200],
    color: theme.palette.internationalOrange[500],
  },
  danger: {
    border: 'transparent',
    background: theme.fill.elserrorAlphaMain16,
    color: theme.colors.errorMain,
  },
  dangerDark: {
    border: 'transparent',
    background: theme.palette.redOrange[100],
    color: theme.palette.redOrange[400],
  },
  dangerLight: {
    border: 'transparent',
    background: theme.palette.redOrange[200],
    color: theme.palette.redOrange[400],
  },
  outline: {
    border: theme.border.defaultWeak,
    background: theme.fill.defaultMain,
    color: theme.colors.defaultStrong,
  },
  inverse: {
    border: 'transparent',
    background: theme.fill.inverseMain,
    color: theme.colors.inverseStrong,
  },
  subtle: {
    border: 'transparent',
    background: theme.fill.defaultWeak,
    color: theme.colors.defaultStrong,
  },
  blur: {
    border: 'transparent',
    background: theme.fill.InverseAlphaMain40,
    color: theme.colors.inverseMain,
    backdropFilter: 'blur(4px)',
  },
  lime: {
    border: 'transparent',
    background: theme.palette.lime[200],
    color: theme.palette.lime[700],
  },
  attending: {
    border: 'transparent',
    background: theme.palette.chateauGreen[200],
    color: theme.palette.chateauGreen[800],
  },
  confirmationPending: {
    border: 'transparent',
    background: theme.palette.mediumPurple[200],
    color: theme.palette.mediumPurple[800],
  },
  rejected: {
    border: 'transparent',
    background: theme.palette.redOrange[200],
    color: theme.palette.redOrange[800],
  },
  default: {
    border: 'transparent',
    background: theme.fill.defaultMain,
    color: theme.colors.defaultStrong,
  },
};

const TagContainer = styled.div`
  backdrop-filter: ${({ $variant }) => variantStyles[$variant].backdropFilter};
  background: ${({ $variant }) => variantStyles[$variant].background};
  border: 1px solid ${({ $variant }) => variantStyles[$variant].border};
  border-radius: ${({ $borderRadius }) => $borderRadius};
  display: inline-flex;
  flex-shrink: 0;
  padding: 6px ${({ theme }) => theme.sizing.xs};
  width: fit-content;
`;